import styled from 'styled-components';
import { mediaMax } from '../Media Template/Media Template';

export const BannerHolder = styled.div.attrs({})`
  width: 100%;
  height: 520px;
  display: flex;
  ${mediaMax.tablet`
    display: -webkit-box;
    overflow-x: hidden;
  `};
`;
